import React, { useState } from 'react';
import Logo from '../assets/logo.png';
import location from '../assets/icons/logo.png';

const Header = ({setLogin, login}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const username = localStorage.getItem('username');
    const handleLogin= ()=>{
        if (!username){
            setLogin(true)
        }
    }

    return (
        <div className='border-b shadow-lg shadow-white/10'>
            <div className='flex items-center justify-between w-full max-w-6xl mx-auto group p-4'>
                <div className='shrink-0'>
                    <img src={Logo} alt="Logo" className='h-8 sm:h-10 md:h-12 w-auto' />
                </div>

                <button 
                    className='md:hidden flex flex-col justify-center items-center w-6 h-6'
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <span className={`bg-gray-700 block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMenuOpen ? 'rotate-45 translate-y-1' : '-translate-y-0.5'}`}></span>
                    <span className={`bg-gray-700 block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm my-0.5 ${isMenuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
                    <span className={`bg-gray-700 block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMenuOpen ? '-rotate-45 -translate-y-1' : 'translate-y-0.5'}`}></span>
                </button>
                <div className='hidden md:flex items-center justify-between gap-4 lg:gap-20'>
                    <nav className='flex items-center gap-4 lg:gap-6 text-sm text-gray-700'>
                        <a href="#ourService" className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200'>Service</a>
                        <a href="#repairService" className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200'>Mobile Service</a>
                        <a href="#ourStores" className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200'>Our stores</a>
                        <a href="#brand" className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200'>Top Brands</a>
                        <a href="#footer" className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200'>Contact Us</a>
                    </nav>
                    
                    <div className='flex items-center gap-4 lg:gap-6'>
                        <div className='flex items-center gap-2 text-sm text-gray-600'>
                            <img src={location} alt="location" className='w-3 h-3' />
                            <p className='hidden sm:block'>Tiruppur</p>
                        </div>
                        <button className='bg-[#42C8B7] text-white px-3 py-2 md:px-6 rounded text-sm md:text-base hover:bg-[#38b2a3] transition-colors duration-200' onClick={handleLogin}>
                            {username? username:"Log In"}
                        </button>
                    </div>
                </div>
            </div>

            {isMenuOpen && (
                <div className='md:hidden bg-white border-t'>
                    <nav className='flex flex-col p-4 gap-4 text-gray-700'>
                        <p className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200 py-2'>Service</p>
                        <p className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200 py-2'>Mobile Service</p>
                        <p className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200 py-2'>Our stores</p>
                        <p className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200 py-2'>Top Brands</p>
                        <p className='hover:text-[#42C8B7] cursor-pointer transition-colors duration-200 py-2'>Contact Us</p>
                        <div className='flex flex-col gap-4 mt-4 pt-4 border-t'>
                            <div className='flex items-center gap-2 text-sm text-gray-600'>
                                <img src={location} alt="location" className='w-4 h-4' />
                                <p>Tiruppur</p>
                            </div>
                            <button className='bg-[#42C8B7] text-white px-4 py-3 rounded text-base hover:bg-[#38b2a3] transition-colors duration-200 w-full' onClick={handleLogin}>
                                {username? username:"Log In"}
                            </button>
                        </div>
                    </nav>
                </div>
            )}
        </div>
    );
};

export default Header;